import { io } from 'socket.io-client';
import { spaceId } from "../basicInfo";
import { useContext, useEffect } from 'react';
import { PlayerContext } from '../../App';
import { syncSpaceToProgramDateTime } from "../container/player/utils/trackSync";

const socket = io('https://api.atomic.radio', { query: { token: undefined }, autoConnect: false, transports: ['websocket', 'polling'] });

export default function FetchData() {
    const { setPlayerState } = useContext(PlayerContext);

    useEffect(() => {
        const updateSpace = (data) => {
            if (data.id !== spaceId ) return;

            setPlayerState((previousState) => {
                const initData = previousState.programDateTime
                    ? syncSpaceToProgramDateTime(data, previousState.programDateTime)
                    : data;

                return {
                    ...previousState,
                    initData,
                };
            });
        };

        socket.on('update_space', updateSpace);
        socket.connect();

        return () => {
            socket.off('update_space', updateSpace);
        };
    }, [setPlayerState]);
    
}
